import { render, staticRenderFns } from "./CSummaryListItem.vue?vue&type=template&id=696b0656&scoped=true&"
import script from "./CSummaryListItem.vue?vue&type=script&lang=js&"
export * from "./CSummaryListItem.vue?vue&type=script&lang=js&"
import style0 from "./CSummaryListItem.vue?vue&type=style&index=0&id=696b0656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696b0656",
  null
  
)

export default component.exports